<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="850px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="addButton"
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar perfil</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>

    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>

      <v-card-title class="mb-0 pb-0">
        <span
          class="title grey--text text--darken-2"
        >
          {{formData.id ? 'Editar perfil' : 'Novo perfil'}}
        </span>
      </v-card-title>

      <v-card-text class="mt-0 pt-0">
        <v-form ref="profileForm" v-model="validForm" lazy-validation class="mt-0 pt-0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm8>
                <v-text-field
                  :disabled="viewForm"
                  type="text"
                  v-model="formData.name"
                  label="Nome do perfil"
                  :rules="$store.state.formRules.required"
                  @keydown.enter.prevent
                  required
                ></v-text-field>
              </v-flex>
              <v-flex sm12>
                <h2
                  class="permissionTitle text-sm-left grey--text text--darken-2 title mb-2"
                  style="font-size:17px !important"
                >Lista de permissões</h2>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-bind:key="ind"
              v-for="(category, ind) in permissionsCategories"
              class="text-sm-left category-line py-2"
            >
              <v-flex :class="['sm2 text-sm-right pr-0 pt-2']">
                <h4 class="pt-0">{{category == 'rpf' ? 'RFP' : getLabel(category) }}</h4>
              </v-flex>

              <v-flex
                :class="[ index < 3 ? 'sm3' : 'sm3', 'text-sm-left pl-4']"
                v-bind:key="index"
                v-for="(permission, index) in permissionsList[ind]"
              >
                <v-switch
                  class="smallSwitch mt-0"
                  :disabled="viewForm"
                  v-model="formData.permissions_id"
                  :label="permission.name == 'anexo' ? `remover ${permission.name}` : `${permission.name == 'editar' ? 'cadastrar/': ''}${permission.name}`"
                  color="primary"
                  :value="permission.id"
                  hide-details
                ></v-switch>
              </v-flex>
            </v-layout>
            <!-- <v-flex sm4 v-bind:key="index" v-for="(permission, index) in permissionsList">
                <v-switch
                  :disabled="viewForm"
                  v-model="formData.permissions_id"
                  :label="permission.name"
                  color="primary"
                  :value="permission.id"
                  hide-details
                ></v-switch>
            </v-flex>-->
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog">Cancelar</v-btn>
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultForm = {
  name: '',
  permissions_id: []
}

const allPermissionsArray = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39
]

export default {
  name: 'profilesForm',

  components: {},

  props: {
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveProfile: Function,
    dialog: Boolean,
    editFormData: Object
  },

  data () {
    return {
      permissionsCategories: [],
      viewForm: false,
      permissionsList: [],
      formData: { ...defaultForm },
      validForm: true,
      hideRemoveOption: ['condomínios', 'contrato', 'documento', 'terceiros', 'usuario'],
      hasAdmin: false
    }
  },

  mounted () {
    this.getPermissions()
  },

  computed: {
    dialogShow () {
      return this.dialog
    }
  },

  watch: {
    dialogShow (val) {
      if (val) {
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true
          } else {
            this.viewForm = false
          }
          this.formData = {
            ...this.editFormData
          }

          this.hasAdmin = this.formData.permissions_id.includes(1)
        }
      } else {
        this.viewForm = false
        this.$refs.profileForm.resetValidation()
        this.formData = { ...defaultForm }
      }
    },

    formData: {
      handler (newValue) {
        if (this.hasAdmin) {
          if (!newValue.permissions_id.includes(1)) {
            newValue.permissions_id = []

            this.hasAdmin = false
          }
        }

        if (newValue.permissions_id[newValue.permissions_id.length - 1] === 1) {
          newValue.permissions_id = allPermissionsArray

          this.hasAdmin = true
        }
      },
      deep: true
    }
  },

  methods: {
    getPermissions () {
      let obj = {
        url: '/api/permission',
        query: '',
        method: 'get',
        noLoader: true
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.permissionsCategories = response.data.reduce(
          (categories, permission) => {
            let category = permission.name.split(' ')[0]
            // if(category.length > 1){
            //   category.pop()
            // }
            // category.concat(' ')
            // console.log(category)
            if (categories.indexOf(category) === -1) {
              categories.push(category)
            }
            return categories
          },
          []
        )

        this.permissionsCategories.sort()
        this.permissionsList = []

        this.permissionsCategories.forEach((cat) => {
          let permissionByCat = response.data.filter((permission) => {
            let category = permission.name.split(' ')[0]
            // if(category.length >1){
            //   category.pop()
            // }

            // category.concat(' ')

            if (category === cat) {
              if (this.hideRemoveOption.includes(cat)) {
                permission.name = permission.name.split(' ').pop()

                // -------- HIDDING OPTION OF REMOVING
                // if (this.hideRemoveOption.includes(cat)) {
                //
                // }
                if (permission.name !== 'remover') {
                  return permission
                }
                // -----------------

                // return permission
              } else {
                permission.name = permission.name.split(' ').pop()

                return permission
              }
            }
          })

          this.permissionsList.push(permissionByCat)
        })
        // console.log("perm", this.permissionsList);
        // this.permissionsList = response.data;
      })
    },

    getLabel (category) {
      switch (category) {
        case 'contrato':
          return 'CONTRATOS'
        case 'documento':
          return 'DOCUMENTAÇÃO'
        case 'perfil':
          return 'PERFIS DE USUÁRIOS'
        case 'relatorio':
          return 'RELATÓRIOS'
        case 'usuario':
          return 'USUÁRIOS'
        case 'padrões':
          return 'PADRÕES DO SISTEMA'
        case 'prestação':
          return 'PRESTAÇÃO DE CONTAS'
        case 'datasheet':
          return 'FICHA TÉCNICA'
        default:
          return category.toUpperCase()
      }
    },

    getPermissionsList (cat) {
      this.permissionsList.reduce((permissions, permission) => {
        let category = permission.name.split(' ')
        if (category.length > 1) {
          category.pop()
        }
        category.join(' ')
        if (category === cat) {
          permission.name = permission.name.split().pop()
          permissions.push(permission)
        }
        return permissions
      }, [])
    },

    resetDialog () {
      this.$props.closeForm()
    },

    doSave () {
      if (!this.$refs.profileForm.validate()) {
        return
      }

      console.log(this.formData)

      if (!this.formData.permissions_id.length) {
        let title = document.querySelector('.permissionTitle')
        title.classList.add('red--text')
        setTimeout(function () {
          title.classList.remove('red--text')
        }, 3000)
        return
      }

      const callback = function () {
        this.$props.closeForm()
      }
      this.$props.saveProfile(this.formData, callback)
    }
  }
}
</script>

<style>
.permissionTitle.red--text,
.permissionTitle.red--text::before {
  content: "*";
  color: #f44336 !important;
}
.category-line {
  border-bottom: solid 1px #ccc;
}
.category-line h3 {
  padding-top: 1em;
}
</style>
